import Vue from 'vue'
import Router from 'vue-router'
//直播课堂
import index from '@/view/index'
import login from '@/view/login'
import admission from '@/view/admission'
import results from '@/view/results'
import state from '@/view/state'
import instructions from '@/view/instructions'
Vue.use(Router)

export default new Router({
	routes: [
		{
			path: '/',
			name: 'login',
			component: login,
			meta: {
				keepAlive: true,//是否缓存
				isBack: true,//是否保存状态
				title: '登录',//title
			}
		},
		{
			path: '/index',
			name: 'index',
			component: index,
			beforeEnter: (to, from, next) => {
				if (from.name == 'instructions' || from.name == 'state') {
					next()
				} else {
					next({ name: 'login' })
				}
				next()
			},
			meta: {
				keepAlive: false,//是否缓存
				isBack: true,//是否保存状态
				title: '我要报名',//title
			}
		},
		{
			path: '/admission',
			name: 'admission',
			component: admission,
			meta: {
				keepAlive: false,//是否缓存
				isBack: true,//是否保存状态
				title: '录取查询',//title
			}
		},
		{
			path: '/login',
			name: 'login',
			component: login,
			meta: {
				keepAlive: true,//是否缓存
				isBack: true,//是否保存状态
				title: '登录',//title
			}
		},
		{
			path: '/results',
			name: 'results',
			component: results,
			meta: {
				keepAlive: false,//是否缓存
				isBack: true,//是否保存状态
				title: '结果查询',//title
			}
		},
		{
			path: '/state',
			name: 'state',
			component: state,
			meta: {
				keepAlive: false,//是否缓存
				isBack: true,//是否保存状态
				title: '录取状态',//title
			}
		},
		{
			path: '/instructions',
			name: 'instructions',
			component: instructions,
			beforeEnter: (to, from, next) => {
				if (from.name != 'login') next({ name: 'login' })
				next()
			},
			meta: {
				keepAlive: false,//是否缓存
				isBack: true,//是否保存状态
				title: '报名须知',//title
			}
		},
	],
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			if (from.meta.keepAlive) {
				from.meta.savedPosition = document.body.scrollTop
			}
			return {
				x: 0,
				y: to.meta.savedPosition || 0
			}
		}
	},
})


// WEBPACK FOOTER //
// ./src/router/index.js